// Shared helpers for the Access & Personalizations card + Access Control modal.

export type AccessTone = "green" | "blue" | "amber" | "gray";

// A member's access level is derived from their real role — there is no
// per-user access column on the backend, so the role drives the badge + scope.
export const ACCESS_BY_ROLE: Record<string, { badge: string; tone: AccessTone; scope: string }> = {
    Admin:        { badge: "Full Access",    tone: "green", scope: "Can manage clinic settings and staff" },
    Doctor:       { badge: "Full Access",    tone: "green", scope: "Can view, edit, and prescribe" },
    Receptionist: { badge: "Limited Access", tone: "amber", scope: "Can view basic info and appointments" },
    Nurse:        { badge: "View Only",      tone: "blue",  scope: "Can view records only" },
};

export const DEFAULT_ACCESS = { badge: "Custom Access", tone: "gray" as AccessTone, scope: "Role-based access" };

export const BADGE_TONE: Record<AccessTone, string> = {
    green: "bg-green-100 text-green-700",
    blue:  "bg-blue-100 text-blue-700",
    amber: "bg-amber-100 text-amber-700",
    gray:  "bg-gray-100 text-gray-600",
};

export function accessForRole(role: string) {
    return ACCESS_BY_ROLE[role] ?? DEFAULT_ACCESS;
}

const AVATAR_COLORS = [
    "from-blue-400 to-blue-600",
    "from-violet-400 to-purple-600",
    "from-teal-400 to-cyan-500",
    "from-orange-400 to-red-500",
    "from-green-400 to-emerald-600",
    "from-pink-400 to-rose-500",
    "from-indigo-400 to-blue-600",
    "from-amber-400 to-orange-500",
];

export function avatarColor(i: number) {
    return AVATAR_COLORS[i % AVATAR_COLORS.length];
}

export function initials(first: string, last: string, email: string) {
    const a = first?.[0] ?? "";
    const b = last?.[0] ?? "";
    return (`${a}${b}`.toUpperCase() || email?.[0]?.toUpperCase() || "?").slice(0, 2);
}
